export default "__VITE_ASSET__CSUJLZ7h__"